const TYPE_HEART_RATE       = 1
const TYPE_BLOOD_PRESSURE   = 2
const TYPE_TEMPERATURE      = 3
const TYPE_BLOOD_SATURATION = 4
const TYPE_GEOFENCING       = 5
const TYPE_CALORIES         = 6
const TYPE_PEDOMETER        = 7
const TYPE_FALLS            = 8
const TYPE_WEIGHT           = 9
const TYPE_LOGS             = 10

const readingTypesRoutes = new Map([
	[ 'heart-rate', 1 ],
	[ 'blood-pressure', 2 ],
	[ 'temperature', 3 ],
	[ 'blood-saturation', 4 ],
	[ 'geofencing', 5 ],
	[ 'calories', 6 ],
	[ 'pedometer', 7 ],
	[ 'falls', 8 ]
])

// used in reading details submenu
const selectedMap = new Map([
	[ 'heart-rate', 1 ],
	[ 'blood-pressure', 2 ],
	[ 'temperature', 3 ],
	[ 'blood-saturation', 4 ],
	[ 'calories', 5 ],
	[ 'pedometer', 6 ],
	[ 'falls', 7 ]
])

const readingTypes = new Map([
	[1, {
		route: 'heart-rate',
		routeName: 'WatchBiometricHeartRate',
		name: 'Heart Rate',
		unit: 'bpm',
		unitHtml: 'bpm',
		cssClass: 'heartbeat',
		icon: 'heartbeat',
		translationKey: 'readings.heartrate'
	}],
	[2, {
		route: 'blood-pressure',
		routeName: 'WatchBiometricBloodPressure',
		name: 'Blood Pressure',
		unit: 'mmHg',
		unitHtml: 'mmHg',
		cssClass: 'bloodpressure',
		icon: 'blood pressure',
		translationKey: 'readings.bloodpressure'
	}],
	[3, {
		route: 'temperature',
		routeName: 'WatchBiometricTemperature',
		name: 'Temperature',
		unit: '°C',
		unitHtml: '&deg;C',
		cssClass: 'temperature',
		icon: 'temperature',
		translationKey: 'readings.temperature'
	}],
	[4, {
		route: 'blood-saturation',
		routeName: 'WatchBiometricBloodSaturation',
		name: 'Blood Saturation',
		unit: '% spO2',
		unitHtml: 'spO<sub>2</sub>',
		cssClass: 'bloodsaturation',
		icon: 'o2',
		translationKey: 'readings.bloodsaturation'
	}],
	[5, {
		route: '',
		routeName: 'WatchGeofencing',
		name: 'Position',
		unit: 'lat lng',
		unitHtml: 'lat lng',
		cssClass: 'position',
		icon: 'geo fencing',
		translationKey: 'readings.position'
	}],
	[6, {
		route: 'calories',
		routeName: 'WatchBiometricCalories',
		name: 'Calories',
		unit: 'kcal',
		unitHtml: 'kcal',
		cssClass: 'calories',
		icon: 'calories',
		translationKey: 'readings.calories'
	}],
	[7, {
		route: 'pedometer',
		routeName: 'WatchBiometricPedometer',
		name: 'Pedometer',
		unit: 'steps',
		unitHtml: 'steps',
		cssClass: 'pedometer',
		icon: 'pedometer',
		translationKey: 'readings.pedometer'
	}],
	[8, {
		route: 'falls',
		routeName: 'WatchBiometricFalls',
		name: 'Falls',
		unit: '',
		unitHtml: '',
		cssClass: 'falls',
		icon: 'fall',
		translationKey: 'readings.falls'
	}],
])

function processReading (reading) {
	return {
		id: Number(reading.id),
		type_id: Number(reading.type_id),
		type: reading.type,

		last: Number(reading.last),
		min: Number(reading.min),
		avg: Number(reading.avg),
		max: Number(reading.max),
		std_dev: Number(reading.std_dev),

		min_last: Number(reading.min_last),
		min_min: Number(reading.min_min),
		min_max: Number(reading.min_max),
		min_avg: Number(reading.min_avg),
		min_std_dev: Number(reading.min_std_dev),

		max_last: Number(reading.max_last),
		max_min: Number(reading.max_min),
		max_max: Number(reading.max_max),
		max_avg: Number(reading.max_avg),
		max_std_dev: Number(reading.max_std_dev),

		reading_time: reading.reading_time,
		reading_time_local: new Date(reading.reading_time),

		samples: Number(reading.samples)
	}
}

function processPosition (reading) {
	return {
		id: Number(reading.id),
		type_id: Number(reading.type_id),
		type: reading.type,
		lat: Number(reading.latitude),
		lng: Number(reading.longitude),
		reading_time: reading.reading_time,
		reading_time_local: new Date(reading.reading_time)
	}
}

function processZones (data) {
	const zones = []
	data.forEach(element => {
		//if (element.positions && element.positions.length) {
			const zone = {}
			zone.id = element.id
			zone.name = element.name
			zone.vertices = element.positions.map(p => { return { lat: parseFloat(p.latitude), lng: parseFloat(p.longitude) } })
			zone.polygon = new google.maps.Polygon({
				paths: zone.vertices,
				strokeColor: '#d31400',
				strokeOpacity: 1,
				strokeWeight: 4,
				fillColor: '#ffffff',
				fillOpacity: 0.35
			})
			zones.push(zone)
		//}
	})
	return zones
}

export default {
	TYPE_HEART_RATE,
	TYPE_BLOOD_PRESSURE,
	TYPE_TEMPERATURE,
	TYPE_BLOOD_SATURATION,
	TYPE_GEOFENCING,
	TYPE_CALORIES,
	TYPE_PEDOMETER,
	TYPE_FALLS,
	TYPE_WEIGHT,
	TYPE_LOGS,
	readingTypes,
	readingTypesRoutes,
	selectedMap,
	processReading,
	processPosition,
	processZones
}



// WEBPACK FOOTER //
// ./src/utils/readings.js